import React from 'react';
import { Text } from '../../../../components/Typography/Typography';
import Button from '../../../../components/UI/Button/Button';
import styles from '../BenchmarkQuestionsPage.module.scss';
import { BenchmarkQuestion } from '../../../../store/benchmark/types';

interface BenchmarkQuestionCardProps {
  question: BenchmarkQuestion;
  onEdit: () => void;
  onDelete: () => void;
}

const BenchmarkQuestionCard: React.FC<BenchmarkQuestionCardProps> = ({
  question,
  onEdit,
  onDelete,
}) => {
  return (
    <div className={styles.row}>
      <div className={styles.mainContent}>
        <div className={styles.questionSection}>
          <Text size="large" weight="medium" color="gray100">
            {question.question}
          </Text>
          {question.tests_for && (
            <div className={styles.testsFor}>
              <Text weight="medium" color="neutral-600">
                Tests For:
              </Text>
              <Text>{question.tests_for}</Text>
            </div>
          )}
        </div>

        <div className={styles.metadata}>
          <div className={styles.queryType}>
            <Text weight="medium" color="neutral-600">
              {question.query_type}
            </Text>
          </div>
          <div className={styles.actions}>
            <Button variant="outline" size="small" onClick={onEdit}>
              Edit
            </Button>
            <Button variant="danger" size="small" onClick={onDelete}>
              Delete
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BenchmarkQuestionCard;
